<template>
  <div class="form-group">
    <label>{{ config.name }} <span v-if="config.required">*</span></label>
    <div class="form-check" v-for="option in options" :key="option.id">
      <label class="form-check-label">
        <input
          type="checkbox"
          class="form-check-input"
          :class="{ 'is-invalid': hasErrors }"
          :value="option.value"
          v-model="selected"
          @change="emitChange"
        />
        {{ option.name }}
      </label>
    </div>
    <div class="invalid-feedback" :class="{ 'd-block': hasErrors }" v-if="hasErrors" v-cloak>
      {{ firstError }}
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  config: Object,
  errors: {
    type: [Array, Object],
    default: () => [],
  },
});

const options = computed(() =>
  props.config.options.filter((option) => option.value !== 'null' && option.value !== '')
);

const selected = ref([]);

const emit = defineEmits(['change']);
const emitChange = () => {
  emit('change', [...selected.value]);
};

const hasErrors = computed(() =>
  Array.isArray(props.errors) ? props.errors.length > 0 : Object.keys(props.errors ?? {}).length > 0
);

const firstError = computed(() => {
  if (Array.isArray(props.errors)) {
    return props.errors[0];
  }
  const first = Object.values(props.errors ?? {})[0];
  return Array.isArray(first) ? first[0] : first;
});
</script>
